import { useCallback } from 'react';

import { Flag } from '../../../../types';

import { resendInHouseVerificationCode } from '../../../../actions/confirmation-actions';
import { useAnalyticsClient } from '../../../../utilities/analytics/analytics-web-client';
import { addFlag } from '../../../../actions/flag-actions';
import { captureErrorMessage } from '../../../../utilities/analytics/error-reporting';
import { useAppDispatch } from '../../../../stores/redux.store';
import { useCreateAccountConfirmationPageState } from '../../../../hooks';
import resendVerificationCodeMessages from '../messages/resendVerificationCode';

import { CREATE_ACCOUNT_CONFIRMATION_PAGE_ID as pageId } from '../constants';
import { useRegisterComponent } from '../../../orchestrator';

export const useRetryAccountCreation = () => {
  useRegisterComponent(useRetryAccountCreation.name);

  const dispatch = useAppDispatch();

  const pageState = useCreateAccountConfirmationPageState();
  const { createNeeded, verifyNeeded, loginType } = pageState;

  const analyticsClient = useAnalyticsClient();

  const dispatchAddFlag = useCallback(
    (flag: Flag) => dispatch(addFlag(flag.type, flag.title, flag.description)),
    [dispatch]
  );

  const resendVerificationCode = async () => {
    analyticsClient.linkClickedEvent(pageId, 'startAgainCreateAccountIdp', {
      loginType,
      confirmationCreateAccountNeeded: createNeeded,
      confirmationVerifyEmailNeeded: verifyNeeded,
    });

    const { mfaToken } = pageState;
    if (!mfaToken) {
      captureErrorMessage('MFA token missing');
      return;
    }

    await dispatch(resendInHouseVerificationCode(mfaToken));
    dispatchAddFlag({
      type: 'success',
      title: resendVerificationCodeMessages.resendVerificationCodeSuccessTitle,
      description: resendVerificationCodeMessages.resendVerificationCodeSuccessDesc,
    });
  };

  return {
    resendVerificationCode,
  };
};
